<template>
  <div v-if="labels.length" class="product-settings-categories">
    <SelectionTiles
      v-slot="{ item }"
      :items="labels"
      :item-key="(label) => label.id"
      :item-selected="
        (label) =>
          props.selectedLabels.some(
            (selectedLabel) => selectedLabel.id === label.id,
          )
      "
      :item-disabled-text="getLabelDisabledText"
      :item-to-string="(label) => label.name"
      :min-item-width="120"
      multi-selection
      @change="selectLabel"
    >
      <Icon :icon="item.icon" />
    </SelectionTiles>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';
import SelectionTiles from 'src/app/components/selectionTiles/SelectionTiles.vue';
import {
  safe18PublishingLabels,
  ExtendedApparelTargetGroupLabel,
} from '@spreadgroup/common-partner-lib/publishing';
import { Composition } from '@spreadgroup/common-partner-lib/composition';

interface Props {
  composition: Composition;
  selectedLabels: ExtendedApparelTargetGroupLabel[];
}
const props = defineProps<Props>();

const store = useStore();
const labels = computed(
  () =>
    Object.values(
      store.state.publishingCore.apparelTargetGroupLabels,
    ) as ExtendedApparelTargetGroupLabel[],
);
const getLabelDisabledText = (label: ExtendedApparelTargetGroupLabel) => {
  return props.composition.metaData?.adultContent &&
    !safe18PublishingLabels.includes(label.id)
    ? 'DESIGNS.CONFIGURATION.PRODUCT_GROUPS.18_PLUS_INFO'
    : null;
};

const emit = defineEmits(['onSelect']);

const selectLabel = (label: ExtendedApparelTargetGroupLabel) => {
  emit('onSelect', label);
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';
@import 'src/scss/styleguide/links';

.product-settings-categories {
  img {
    height: 70px;
  }
}
</style>
